module.exports = __webpack_public_path__ + "media/images/iconSocialShare__okGreen--dark-a9494c52989f5823900fe652ba620554.png";